import * as utils from 'prebid.js/src/utils'
import { IBid } from '../../../../../typings/IOpenRTB'
import { INativeResponse } from '../../../../../typings/IPrebid'
import Logger from '../../../../helpers/Logger'

const log = (...messages) => Logger.custom('s2s', ...messages)

/** Can use a major refactor. Borrowed logic from partner adapter. */
export const parseNativeResponse = (bid: IBid): INativeResponse => {
  const native: INativeResponse = {}
  if (bid.hasOwnProperty('adm')) {
    let adm: any = {}

    if (typeof bid.adm === 'string') {
      try {
        adm = { native: JSON.parse(bid.adm as string) }
      } catch (ex) {
        log('cannot parse native response')
      }
    } else if (typeof bid.adm === 'object') {
      adm = { native: bid.adm }
    }

    if (bid.admobject) {
      adm = bid.admobject
    }

    /**
     * Unwrap if necessary ie. Triplelift
     * TL might actually be returning the response to spec
     * while others do not.
     * */
    if (adm.native.native) {
      adm.native = adm.native.native
    }

    /**
     * Mediagrid native response uses adm_native
     */
    if (bid.adm_native) {
      adm.native = bid.adm_native
    }

    if (
      adm &&
      adm.native &&
      adm.native.assets &&
      adm.native.assets.length > 0
    ) {
      for (let i = 0, len = adm.native.assets.length; i < len; i++) {
        switch (adm.native.assets[i].id) {
          case NATIVE_ASSETS.TITLE.ID:
            native.title =
              adm.native.assets[i].title && adm.native.assets[i].title.text
            break
          case NATIVE_ASSETS.IMAGE.ID:
            native.image = {
              url: adm.native.assets[i].img && adm.native.assets[i].img.url,
              height: adm.native.assets[i].img && adm.native.assets[i].img.h,
              width: adm.native.assets[i].img && adm.native.assets[i].img.w
            }
            break
          case NATIVE_ASSETS.ICON.ID:
            native.icon = {
              url: adm.native.assets[i].img && adm.native.assets[i].img.url,
              height: adm.native.assets[i].img && adm.native.assets[i].img.h,
              width: adm.native.assets[i].img && adm.native.assets[i].img.w
            }
            break
          case NATIVE_ASSETS.VIDEO.ID:
            native.video = {
              vastXml:
                adm.native.assets[i].video && adm.native.assets[i].video.vasttag
            }
            break
          case NATIVE_ASSETS.SPONSOREDBY.ID:
          case NATIVE_ASSETS.BODY.ID:
          case NATIVE_ASSETS.LIKES.ID:
          case NATIVE_ASSETS.DOWNLOADS.ID:
          case NATIVE_ASSETS.PRICE:
          case NATIVE_ASSETS.SALEPRICE.ID:
          case NATIVE_ASSETS.PHONE.ID:
          case NATIVE_ASSETS.ADDRESS.ID:
          case NATIVE_ASSETS.DESC2.ID:
          case NATIVE_ASSETS.CTA.ID:
          case NATIVE_ASSETS.RATING.ID:
          case NATIVE_ASSETS.DISPLAYURL.ID:
            native[NATIVE_ASSET_ID_TO_KEY_MAP[adm.native.assets[i].id]] =
              adm.native.assets[i].data && adm.native.assets[i].data.value
            break
        }
      }

      native.clickUrl = adm.native.link && adm.native.link.url
      native.clickTrackers =
        (adm.native.link && adm.native.link.clicktrackers) || []

      native.impressionTrackers = (adm.native.imptrackers || []).map((t) =>
        interpolateAuctionPrice(t, bid.price)
      )

      native.eventTrackers = adm.native.eventtrackers || []
      ;(native.eventTrackers || []).forEach((tracker) => {
        tracker.url = interpolateAuctionPrice(tracker.url, bid.price)
      })

      native.jstracker =
        interpolateAuctionPrice(adm.native.jstracker, bid.price) || ''
      if (bid.nurl) {
        native.impressionTrackers?.push(
          interpolateAuctionPrice(bid.nurl, bid.price)
        )
      }
    }
  }

  return native
}

const interpolateAuctionPrice = (str, price) =>
  str && str.replace(/\$\{AUCTION_PRICE\}/g, String(price))

const NATIVE_ASSETS = {
  TITLE: { ID: 1, KEY: 'title', TYPE: 0 },
  IMAGE: { ID: 2, KEY: 'image', TYPE: 0 },
  ICON: { ID: 3, KEY: 'icon', TYPE: 0 },
  SPONSOREDBY: { ID: 4, KEY: 'sponsoredBy', TYPE: 1 }, // please note that type of SPONSORED is also 1
  BODY: { ID: 5, KEY: 'body', TYPE: 2 }, // please note that type of DESC is also set to 2
  CLICKURL: { ID: 6, KEY: 'clickUrl', TYPE: 0 },
  VIDEO: { ID: 7, KEY: 'video', TYPE: 0 },
  EXT: { ID: 8, KEY: 'ext', TYPE: 0 },
  DATA: { ID: 9, KEY: 'data', TYPE: 0 },
  LOGO: { ID: 10, KEY: 'logo', TYPE: 0 },
  SPONSORED: { ID: 11, KEY: 'sponsored', TYPE: 1 }, // please note that type of SPONSOREDBY is also set to 1
  DESC: { ID: 12, KEY: 'data', TYPE: 2 }, // please note that type of BODY is also set to 2
  RATING: { ID: 13, KEY: 'rating', TYPE: 3 },
  LIKES: { ID: 14, KEY: 'likes', TYPE: 4 },
  DOWNLOADS: { ID: 15, KEY: 'downloads', TYPE: 5 },
  PRICE: { ID: 16, KEY: 'price', TYPE: 6 },
  SALEPRICE: { ID: 17, KEY: 'saleprice', TYPE: 7 },
  PHONE: { ID: 18, KEY: 'phone', TYPE: 8 },
  ADDRESS: { ID: 19, KEY: 'address', TYPE: 9 },
  DESC2: { ID: 20, KEY: 'desc2', TYPE: 10 },
  DISPLAYURL: { ID: 21, KEY: 'displayurl', TYPE: 11 },
  CTA: { ID: 22, KEY: 'cta', TYPE: 12 }
}

const NATIVE_ASSET_ID_TO_KEY_MAP = {}
const NATIVE_ASSET_KEY_TO_ASSET_MAP = {}

// loading NATIVE_ASSET_ID_TO_KEY_MAP
utils._each(NATIVE_ASSETS, (anAsset) => {
  NATIVE_ASSET_ID_TO_KEY_MAP[anAsset.ID] = anAsset.KEY
})
// loading NATIVE_ASSET_KEY_TO_ASSET_MAP
utils._each(NATIVE_ASSETS, (anAsset) => {
  NATIVE_ASSET_KEY_TO_ASSET_MAP[anAsset.KEY] = anAsset
})
